<template>
<div class="chapter">
<div class="inner_page">
<p class="para"><a id="fm_author"></a><a id="page_viii">David Lehman was born in New York City in 1948. Educated at Stuyvesant High School and Columbia University, he spent two years as a Kellett Fellow at Clare College, Cambridge, and worked as Lionel Trilling’s research assistant upon his return from England. He is the author of eight books of poetry, including <span class="txit">Yeshiva Boys</span> (2009), <span class="txit">When a Woman Loves a Man</span> (2005), <span class="txit">The Daily Mirror</span> (2000), and <span class="txit">Valentine Place</span> (1996). His <span class="txit">New and Selected Poems</span> is forthcoming from Scribner. He is the editor of <span class="txit">The Oxford Book of American Poetry</span> (Oxford, 2006) and <span class="txit">Great American Prose Poems: From Poe to the Present</span> (Scribner, 2003). <span class="txit">A Fine Romance: Jewish Songwriters, American Songs</span> (Nextbook/Schocken), the most recent of his six nonfiction books, won the Deems Taylor Award from the American Society of Composers, Authors, and Publishers (ASCAP) in 2010. Among Lehman’s other books are a study in detective novels (<span class="txit">The Perfect Murder</span>), a group portrait of the New York School of poets (<span class="txit">The Last Avant-Garde</span>), and an account of the scandal sparked by the revelation that a Yale University eminence had written for a pro-Nazi newspaper in his native Belgium in World War II (<span class="txit">Signs of the Times: Deconstruction and the Fall of Paul de Man</span>). He teaches in the graduate writing program of The New School and lives in New York City and in Ithaca, New York.</a></p><a id="page_viii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm_author.vue?02c67cf9